import React from 'react';

export function CalendarDot() {
  return (
    <div className="tile-icon-wrap" aria-hidden="true">
      <span className="material-icons">fiber_manual_record</span>
    </div>
  );
}

export function CalendarIcon() {
  return (
    <span className="material-icons">calendar_today</span>
  );
}

export function NextIcon() {
  return (
    <span>›</span>
  );
}

export function PrevIcon() {
  return (
    <span>‹</span>
  );
}
